module["exports"] = [
  "Maria",
  "Anna",
  "Margareta",
  "Elisabeth",
  "Eva",
  "Birgitta",
  "Kristina",
  "Karin",
  "Elisabet",
  "Marie"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/name/first_name_women.js
// module id = 1396
// module chunks = 0